export function getReleaseTag(commitSha: string | undefined): string {
  return commitSha ? `release-${commitSha.slice(0, 7)}` : '';
}
